import React from "react";
import { Route, Routes } from "react-router-dom";
import FireInspectionScheduleComponent from "./FireInspectionScheduleComponent";
import AddFireInspectionScheduleComponent from "./AddFireInspectionScheduleComponent";
import FireInspectionScheduleDetailComponent from "./FireInspectionScheduleDetailComponent";

export default function FireInspectionScheduleRoutes() {
  return (
    <Routes>
      <Route path="*" element={<FireInspectionScheduleComponent />} />
      <Route path="/add/" element={<AddFireInspectionScheduleComponent />} />
      <Route
        path="/detail/"
        element={<FireInspectionScheduleDetailComponent />}
      />
    </Routes>
  );
}
